/**
 * Created by vsliwka on 02/03/2017.
 */
export class ServiceErrorModel {
  public LEVEL_WARN = 'WARNING';
  public LEVEL_ERROR = 'ERROR';

  public errorMessageKey = '';
  public status = 0;
  public severity = '';
  public parameters: string[] = [];
  public statusText = '';

  constructor() {}
}
